
import { useDispatch } from "react-redux";
import { uploadFile } from "../../store/CoreSlice";
import LinearLoader from "./LinearLoader";
import { toggleLinearLoader } from "../../store/LoaderSlice";

function FileInput({multiple, children, uniqueID, uploadDirectly, disabled, storeDataType, name, error} : any) {
    const dispatch : any = useDispatch();
    const handleFileChange = (event : any) => {
        if(uploadDirectly) {
            const formdata = new FormData();
            for(var i = 0; i < event.target.files.length; i++) 
                formdata.append('file', event.target.files[i]);
            dispatch(uploadFile(formdata, storeDataType));
        }
    }

    return (
        <>
            <label className="block cursor-pointer" htmlFor={uniqueID}>
                { children }
            </label>
            <LinearLoader />
            <input 
                disabled = {disabled} 
                id={uniqueID} 
                className="hidden" 
                type="file" 
                multiple = {multiple}  
                onChange={handleFileChange}
                name = {name}
            />

            {
                error && 
                <small className='display-block text-error'> {error} </small>
            }
        </>
    )
}

FileInput.defaultProps = {
    multiple : false,
    uploadDirectly : true,
    disabled : false,
    storeDataType : 'replace',
    name : '',
    error : ''
}

export default FileInput